import React from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'src/hooks/store'
import { selectCartDetails, selectIsCartDrawerOpen } from 'src/redux/cart/selectors'
import { closeCartDrawer } from 'src/redux/cart/slice'
import DrawerWrapper from '../DrawerWrapper/DrawerWrapper'
import useSlidePosition from '../SlideFromEdge/useSlidePosition'
import PageNavigation from './components/PageNavigation'
import { CartPage } from './types'
import { getCartPages } from './utils'

const CartDrawer = () => {
  const dispatch = useAppDispatch()
  const cartDetails = useSelector(selectCartDetails)
  const isCartDrawerOpen = useSelector(selectIsCartDrawerOpen)

  const handleNext = () => {
    slideForward()
  }

  const pages: CartPage[] = getCartPages({ onNext: handleNext, initialValues: cartDetails })

  const { slideDirection, slideForward, slideBackward, pageIndex, canGoBack, resetPages } =
    useSlidePosition(pages.length - 1)
  const currentPage = pages[pageIndex] ?? pages[0]

  const handleBack = () => {
    slideBackward()
    if (!canGoBack) {
      dispatch(closeCartDrawer())
    }
  }

  return (
    <DrawerWrapper
      onClose={() => dispatch(closeCartDrawer())}
      onBack={handleBack}
      isVisible={isCartDrawerOpen}
    >
      <PageNavigation
        title={currentPage.title}
        pageIndex={pageIndex}
        slideDirection={slideDirection}
      >
        {currentPage.component}
      </PageNavigation>
    </DrawerWrapper>
  )
}

export default CartDrawer
